export { getLongLang } from './long.js';
export { getShortLang } from './short.js';

const providerLang = 'VK ID';

export { providerLang };
